
document.addEventListener('click', (e) => {
  // Close button
  if (e.target.closest('.wholesale-popup__close')) {
    e.target.closest('.wholesale-popup').close();
    return;
  }

  // Backdrop click (click on the <dialog> element itself, outside the content)
  if (e.target.tagName === 'DIALOG') {
    e.target.close();
    return;
  }

  // Continue button
  const continueBtn = e.target.closest('.wholesale-continue-btn');
  if (continueBtn && !continueBtn.disabled) {
    continueBtn.classList.add('is-loading');
    continueBtn.disabled = true;
    const qty = document.querySelector('.quantity__input')?.value || 1;
    const href = continueBtn.dataset.href.replace('{qty}', qty);
    setTimeout(() => {
      window.location.href = href;
    }, 500);
    return;
  }

});

// Reset buttons if user navigates back via browser cache
window.addEventListener('pageshow', () => {
  document.querySelectorAll('.wholesale-btn, .wholesale-continue-btn').forEach((btn) => {
    btn.classList.remove('is-loading');
    btn.disabled = false;
  });
});
